<template>
  <div class="BlockList">
    <div class="BlockList-W">
      <div class="productbox">
        <div class="productleft">
          <img src="../../../assets/pc/Admin/logo.png" />
        </div>
        <div class="productright">
          <div class="login">You are logged in</div>
          <div class="titbox">
            <div class="titleft">
              <img
                src="../../../assets/pc/Admin/black.png"
                @click="blacks"
              />Add new product
            </div>
            <div class="titright" @click="Save">Save</div>
          </div>
          <!-- 产品开始 -->
          <div class="productAll">
            <div class="productAllbox">
              <div class="productli">
                <div class="procuctlitit">Product name</div>
                <input
                  type="text"
                  placeholder="Enter name"
                  v-model="productName"
                />
              </div>

              <div class="productli">
                <div class="procuctlitit">Fund pool</div>
                <!-- <input
                  type="text"
                  placeholder="Enter fund quantity."
                  v-model="fundAmount"
                  @input="validateNumber1"
                /> -->
                <input
                  type="text"
                  placeholder="Enter fund quantity."
                  v-model="fundAmount"
                />
              </div>
            </div>
          </div>
          <!-- 产品结束 -->
          <div class="titcontent">
            <div class="tabheader">
              <div>Target name</div>
              <div>Position cost</div>
              <div>Position quantity</div>
              <div>Holding period</div>
              <div>Holding price</div>
              <div>Action</div>
              <div>
                <span class="tabadd" @click="addtarget">Add new target</span>
              </div>
            </div>
            <div class="tabcontent">
              <ul v-if="markArr.length > 0">
                <li v-for="(item, index) in markArr" :key="index">
                  <div>{{ item.markName }}</div>
                  <div>{{ item.holdCost }} U</div>
                  <div>{{ item.holdAmount }}</div>
                  <div>{{ item.holdTime }}</div>
                  <div>{{ item.holdPrice }}U</div>
                  <div>
                    <img
                      src="../../../assets/pc/Admin/delete1.png"
                      @click="deleteFormData(index)"
                    />
                  </div>
                  <div class="adddetail"></div>
                </li>
              </ul>
              <div class="nodata" v-if="markArr.length == 0">
                <img src="../../../assets/pc/Login/nodata.png" />
                <div class="nodatatit">No data</div>
              </div>
            </div>
          </div>
          <div>
            <el-pagination
              background
              small
              :hide-on-single-page="value"
              :current-page.sync="PaginationIndex"
              :page-size="20"
              :pager-count="5"
              layout="prev, jumper, next"
              @current-change="CurrentChange"
              :total="total1"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="BlockListadd" v-show="aflog">
      <div class="BlockListadd-W">
        <div class="addtit">Add new target</div>
        <el-form ref="form" :model="form" :rules="rules">
          <div class="putext">
            <el-form-item prop="markName">
              <el-input
                v-model="form.markName"
                class="inpttext"
                placeholder="Target name"
              ></el-input>
            </el-form-item>
          </div>
          <div class="putext" style="display: flex">
            <el-form-item prop="holdCost">
              <el-input
                v-model="form.holdCost"
                class="inpttext"
                placeholder="Position cost"
              ></el-input>
            </el-form-item>
            <div class="putextu">U</div>
          </div>
          <div class="putext">
            <el-form-item prop="holdAmount">
              <el-input
                v-model="form.holdAmount"
                class="inpttext"
                placeholder="Position quantity"
              ></el-input>
            </el-form-item>
          </div>
          <div class="putext">
            <el-form-item prop="holdTime">
              <!-- <el-input
                v-model="form.holdTime"
                class="inpttext"
                placeholder="Holding period"
              ></el-input> -->
              <!-- <el-date-picker
                v-model="form.holdTime"
                type="date"
                placeholder="Holding period"
              >
              </el-date-picker> -->
              <el-date-picker
                type="date"
                placeholder="mm/dd/yyyy"
                v-model="form.holdTime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd hh:mm:ss"
              ></el-date-picker>
            </el-form-item>
          </div>
          <div class="putext" style="display: flex">
            <el-form-item prop="holdPrice">
              <el-input
                v-model="form.holdPrice"
                class="inpttext"
                placeholder="Holding price"
              ></el-input>
            </el-form-item>
            <div class="putextu">U</div>
          </div>
          <div class="putbottom">
            <div class="close" @click="close">Close</div>
            <div class="submit" @click="login">OK</div>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { GetaddProduct,base1 } from "@/assets/server/api";
import axios from "axios";
export default {
  props: ["flog", "flogb"],
  data() {
    return {
      markArr: [],
      productName: "",
      fundAmount: "",
      userId: "",
      aflog: false,
      value: "",
      PaginationIndex: 1,
      total1: 20,

      form: {
        markName: "",
        holdCost: "",
        holdAmount: "",
        holdTime: "",
        holdPrice: "",
      },
      rules: {
        markName: [
          {
            required: true,
            message: "markName  is required",
            trigger: "change",
          },
        ],
        holdCost: [
          {
            required: true,
            message: "Position cost  is required",
            trigger: "change",
          },
          {
            validator: (rule, value, callback) => {
              if (!/^\d+(\.\d{1,8})?$/.test(value)) {
                callback(new Error("Position cost must be a positive number"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        holdAmount: [
          {
            required: true,
            message: "Position quantity  is required",
            trigger: "change",
          },
          {
            validator: (rule, value, callback) => {
              if (!/^\d+(\.\d{1,8})?$/.test(value)) {
                callback(new Error("Position quantity must be a positive number"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        holdPrice: [
          {
            required: true,
            message: "Holding price  is required",
            trigger: "change",
          },
          {
            validator: (rule, value, callback) => {
              if (!/^\d+(\.\d{1,8})?$/.test(value)) {
                callback(new Error("Holding price must be a positive number"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
      },
    };
  },
  components: {},
  created() {},
  mounted() {
    if (
      this.userId !== "" ||
      this.userId !== null ||
      this.userId !== undefined
    ) {
      this.userId = localStorage.getItem("auserId");
     // console.log(this.userId);
    }
  },
  watch: {
    deep: true,
    flog(val) {
      this.floag = val;
    },
    flogb(val) {
    //  console.log(val);
      this.floagb = val;
    },
  },
  methods: {
    // validateNumber1(event) {
    //   let value = event.target.value;
    //   // 只允许输入数字
    //   if (!/^\d*$/.test(value)) {
    //     value = value.replace(/[^\d]/g, '');
    //   }
    //   this.fundAmount = value;
    // },
    validateNumber(event) {
      let value = event.target.value;
      if (!/^\d*\.?\d{0,8}$/.test(value)) {
        this.form.holdCost = value.slice(0, -1);
        this.form.holdAmount = value.slice(0, -1);
        this.form.holdPrice = value.slice(0, -1);
        // holdAmount: "",
        // holdTime: "",
        // holdPrice: "",
      }
    },
    deleteFormData(index) {
      this.markArr.splice(index, 1);
    },

    blacks() {
      this.$router.push("/pc/Index");
    },
    CurrentChange(val) {
      //  console.log(val);
      this.PaginationIndex = val;
    },
    login() {
      this.$refs.form.validate(async (success) => {
        if (success) {
      const formCopy = { ...this.form };
      this.markArr.push(formCopy);
      this.aflog=false;
      }
    })
      // console.log(this.form);
      // this.markArr1.push(this.form);
      // console.log(this.markArr);
      // this.markArr1=this.markArr;
    },
    close() {
      this.aflog = false;
      this.form.markName = "";
      this.form.holdCost = "";
      this.form.holdAmount = "";
      this.form.holdTime = "";
      this.form.holdPrice = "";
      // form: {
      //   markName: "",
      //   holdCost: "",
      //   holdAmount: "",
      //   holdTime: "",
      //   holdPrice: "",
      // },
    },
    addtarget() {
      this.form.markName = "";
      this.form.holdCost = "";
      this.form.holdAmount = "";
      this.form.holdTime = "";
      this.form.holdPrice = "";
      this.aflog = true;
    },
    Save() {
      // this.$refs.form.validate(async (success) => {
      //   //    if (this.validatePassword()) {
      //   console.log(this.form);
      //   if (success) {
      const params = {
        productName: this.productName,
        fundAmount: this.fundAmount,
        userId: this.userId,

        markArr: this.markArr,
      };

      axios
        .post(
          //"https://explorer.tfsc.io/tfscBrowser/contract/saveTempContractInfo",
          base1 + "addProduct",
          params,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          // 请求成功状态为200说明添加成功
          //console.log(res);
          // console.log(res.data.code);
          // console.log(res.data.result);
          if (res.data.code == 200) {
            this.$router.push("/pc/Index");
            // console.log(res.code);
            //this.form.sourceCode="";
            // this.$refs.form.resetFields();
          } else {
            // this.$refs.form.resetFields();
            this.$message(res.result);
            return false;
          }
        })
        .catch((error) => {
          // console.log(error);
          this.$message(" This field are not filled in ");
        });
    
        }
    //   })
    // },
  },
};
</script>
<style lang="less">
/deep/.el-message {
  z-index: 99999999999 !important;
  background-color: #fff !important;
  /* 设置文本颜色为白色 */
  color: white !important;

  /* 其他样式调整，根据需要自行添加 */
}
</style>
<style lang="less" scoped>
.BlockList {
  background: #000;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  overflow: auto;

  .BlockList-W {
    width: 1440px;
    margin: 0 auto;
    height: 900px;
    background: #161920;
    border-radius: 0px 0px 0px 0px;
    .productbox {
      display: flex;
      .productleft {
        width: 120px;
        min-height: 900px;
        background: #0c1119;
        border-radius: 0px 0px 0px 0px;
        img {
          width: 44px;
          height: 44px;
          margin-top: 15px;
          margin-left: 38px;
        }
      }
      .productright {
        width: 1320px;
        background: #161920;
        .login {
          font-family: Alibaba PuHuiTi 3, Alibaba PuHuiTi 30;
          font-weight: 500;
          font-size: 18px;
          color: rgba(255, 255, 255, 0.6);
          margin-top: 24px;
          margin-left: 40px;
        }
        .titbox {
          display: flex;
          justify-content: space-between;
          width: 1280px;

          height: 80px;
          line-height: 80px;
          border-radius: 6px;
          background: linear-gradient(
            99deg,
            #262932 0%,
            rgba(33, 38, 49, 0) 100%
          );
          border: 1px solid rgba(255, 255, 255, 0.1);
          margin: 0 auto;
          margin-top: 23px;
          .titleft {
            font-family: Alibaba PuHuiTi 3, Alibaba PuHuiTi 30;
            font-weight: 900;
            font-size: 28px;
            color: #3cf6f0;
            margin-left: 20px;
            img {
              width: 36px;
              height: 36px;
              margin-top: 22px;
              cursor: pointer;
            }
          }
          .titright {
            width: 72px;
            height: 39px;
            line-height: 39px;
            background: #252932;
            border-radius: 5px 5px 5px 5px;
            border: 1px solid #464a52;
            margin-right: 20px;
            text-align: center;
            margin-top: 20px;
            font-family: Alibaba PuHuiTi 3, Alibaba PuHuiTi 30;
            font-weight: 500;
            font-size: 18px;
            color: #ffffff;
            cursor: pointer;
          }
        }
        .productAll {
          width: 1280px;
          height: 80px;
          background: #1f232b;
          border: 1px solid #3a3e46;
          border-radius: 6px;
          margin: 0 auto;
          margin-top: 20px;
          .productAllbox {
            display: flex;
            .productli {
              margin-top: 16px;
              margin-left: 20px;
              width: 250px;
              // border: 1px solid red;
              .procuctlitit {
                font-family: Alibaba PuHuiTi 3, Alibaba PuHuiTi 30;
                font-weight: 400;
                font-size: 16px;
                color: #797b7f;
              }
              input {
                width: 200px;
                height: 28px;
                line-height: 28px;
                border: none;

                color: #ffffff;
                border-bottom: 1px solid #d8d8d8;
              }
              input::placeholder {
                font-family: Alibaba PuHuiTi 3, Alibaba PuHuiTi 30;
                font-weight: 400;
                font-size: 14px;
                color: rgba(255, 255, 255, 0.2);
              }
            }
          }
        }
        .titcontent {
          width: 1280px;
          margin: 0 auto;
          .tabheader {
            display: flex;
            .tabadd {
              width: 162px;
              height: 39px;
              line-height: 39px;
              background: #2a303a;
              border-radius: 5px 5px 5px 5px;
              border: 1px solid #464a52;
              text-align: center;
              cursor: pointer;
              color: #fff;
              display: inline-block;
            }
            div {
              font-family: Alibaba PuHuiTi 3, Alibaba PuHuiTi 30;
              font-weight: 500;
              font-size: 14px;
              color: rgba(255, 255, 255, 0.4);
              height: 70px;
              line-height: 70px;
            }
            div:nth-child(1) {
              width: 15%;
              padding-left: 20px;
            }
            div:nth-child(2) {
              width: 10%;
              text-align: center;
            }
            div:nth-child(3) {
              width: 10%;
              text-align: center;
            }
            div:nth-child(4) {
              width: 15%;
              text-align: center;
            }
            div:nth-child(5) {
              width: 10%;
              text-align: center;
            }
            div:nth-child(6) {
              width: 10%;
              text-align: center;
            }
            div:nth-child(7) {
              width: 30%;
              text-align: right;
              padding-right: 20px;
            }
          }
          .tabcontent {
            width: 1280px;
            margin: 0 auto;
            ul {
              li {
                display: flex;
                font-family: Alibaba PuHuiTi 3, Alibaba PuHuiTi 30;
                font-weight: 400;
                font-size: 16px;
                color: #ffffff;
                div:nth-child(1) {
                  width: 15%;
                  padding-left: 20px;
                }
                div:nth-child(2) {
                  width: 10%;
                  text-align: center;
                }
                div:nth-child(3) {
                  width: 10%;
                  text-align: center;
                }
                div:nth-child(4) {
                  width: 15%;
                  text-align: center;
                }
                div:nth-child(5) {
                  width: 10%;
                  text-align: center;
                }
                div:nth-child(6) {
                  width: 10%;
                  text-align: center;
                  img {
                    width: 25px;
                    height: 25px;
                    cursor: pointer;
                    margin-top: 18px;
                  }
                }
                div:nth-child(7) {
                  width: 30%;
                  text-align: right;
                }
                .detail {
                  display: flex;
                  padding-right: 20px;
                  .datailtit {
                    width: 130px;
                    text-align: right;
                    font-family: Alibaba PuHuiTi 3, Alibaba PuHuiTi 30;
                    font-weight: 400;
                    font-size: 16px;
                    color: #3efff9;
                    cursor: pointer;
                    padding-right: 20px;
                  }
                  img {
                    width: 25px;
                    height: 25px;
                    margin-top: 16px;
                    cursor: pointer;
                  }
                }
              }
              li:nth-child(even) {
                width: 1280px;
                height: 60px;
                line-height: 60px;
                background: #161920;
                border-radius: 10px;
              }
              li:nth-child(odd) {
                width: 1280px;
                height: 60px;
                line-height: 60px;
                background: #1c1f26;
                border-radius: 10px;
              }
            }
            .nodata {
              margin-top: 209px;
              margin-left: 610px;
              img {
                width: 60px;
                height: 60px;
              }
              .nodatatit {
                font-family: Alibaba PuHuiTi 3, Alibaba PuHuiTi 30;
                font-weight: 700;
                font-size: 18px;
                color: #737579;
                margin-top: 15px;
                // text-align: center;
              }
            }
          }
        }
      }
    }
  }
  .BlockListadd {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 0;
    background: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    overflow: auto;
    .BlockListadd-W {
      width: 302px;
      height: 371px;
      background: #252931;
      border-radius: 10px 10px 10px 10px;
      position: absolute;
      z-index: 0 !important;
      // border: 1px solid red;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      .addtit {
        font-family: Alibaba PuHuiTi 3, Alibaba PuHuiTi 30;
        font-weight: 900;
        font-size: 20px;
        color: #ffffff;
        margin-top: 26px;
        text-align: center;
      }
      .putext {
        width: 242px;
        height: 50px;
        margin: 0 auto;
        .putextu {
          font-family: Alibaba PuHuiTi 3, Alibaba PuHuiTi 30;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          position: absolute;
          right: 30px;
          padding-top: 10px;
        }
        /deep/.el-input__inner {
          background: #252931 !important;
          border: none;
          border-bottom: 1px solid #677186;
          border-radius: 0px !important;
          padding-left: 0px;
          font-family: Alibaba PuHuiTi 3, Alibaba PuHuiTi 30;
          font-weight: 400;
          font-size: 14px;
          color: #fff;
          width: 242px;
        }
        /deep/.el-input__inner::placeholder {
          font-family: Alibaba PuHuiTi 3, Alibaba PuHuiTi 30;
          font-weight: 400;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.4);
        }
        /deep/.el-input__icon {
          margin-left: 200px;
        }
      }
      .putbottom {
        display: flex;
        .close {
          font-family: Alibaba PuHuiTi 3, Alibaba PuHuiTi 30;
          font-weight: 400;
          font-size: 13px;
          color: #3cf6f0;
          height: 27px;
          line-height: 27px;
          margin-left: 155px;
          width: 60px;
          cursor: pointer;
        }
        .submit {
          width: 60px;
          height: 27px;
          line-height: 27px;
          text-align: center;
          background: #3cf6f0;
          border-radius: 5px 5px 5px 5px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
<style scoped>
/deep/.el-pagination.is-background .btn-prev {
  /* color: #151515; */
}
/deep/.el-icon-arrow-right:before {
  color: #fff !important;
}
/deep/.el-pagination__jump {
  color: #000 !important;
  margin-left: 0px !important;
}
/deep/.el-pagination {
  display: flex;
  justify-content: right;
}
/deep/.el-pagination.is-background .btn-next {
  width: 32px;
  height: 32px;
  background: #151515;
  border-radius: 6px 6px 6px 6px;
}

/deep/ .el-pagination.is-background .btn-prev {
  width: 32px;
  height: 32px;
  background: #151515;
  border-radius: 6px 6px 6px 6px;
}
/deep/.el-el-pagination__jump {
  content: "page";

  font-size: 18px;
  font-family: HarmonyOS Sans-Medium, HarmonyOS Sans;
  font-weight: 500;
  color: #141414;
}
/deep/.el-pagination__editor.el-input {
  margin-left: -25px !important;
}
/deep/ .el-pagination__editor.el-input .el-input__inner {
  width: 32px;
  height: 32px;

  /* background-size: cover; */
  text-align: center;
  border: none !important;
  font-family: Roboto, Roboto;
  font-weight: 500;
  font-size: 13px;
  color: #dddddd;
  background: #000;
  /* margin-left: 16px;
          margin-right: 16px; */
}
</style>
